// const Api = "192.168.3.8:2001";
// const Api = "store.projmantech.com";
const Api = "inventory.infotechitsolutionsbd.com";
// const Api = '192.168.3.7:2001'

export default Api;
